import React from 'react';
import {withFormik} from "formik";
import * as Yup from "yup";
import {passwordInstructions, passwordRegex} from "../validators";
import {Link} from "react-router-dom";
import config from "../config";


function BusinessPasswordResetForm(props) {
  const {
    values,
    touched,
    errors,
    isValid,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    submitCount,
    status,
  } = props;

  if (status === 'success') {
    return (
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          Your password has been changed successfully. <Link to={config.routes.businessLogin}>Click here to login</Link>
        </div>
      </div>
    )
  } else if (status === 'invalid') {
    return (
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          The password reset link is invalid. Please contact support.
        </div>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          <div className={'form-group'}>
            <label htmlFor="password">New Password</label>
            <input
              className={"form-control"}
              id={"password1"}
              type={"password"}
              value={values.password1}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          <div className={'form-group'}>
            <label htmlFor="password">Confirm Password</label>
            <input
              className={"form-control"}
              id={"password2"}
              type={"password"}
              value={values.password2}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {touched.password2 && errors.password2 && (
              <small className="error form-text">
                {errors.password2}
              </small>
            )}
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className={"col-md-12 col-lg-6"}>
          <button type="submit"
                  className="btn btn-primary btn-xlg btn-block btn-pointer"
                  disabled={isSubmitting || !isValid}>
            Change Password
          </button>
        </div>
      </div>
    </form>
  );
}

export default withFormik({
  mapPropsToValues: (props) => ({
    password1: '',
    password2: '',
  }),
  validationSchema: Yup.object().shape({
    password1: Yup.string().matches(passwordRegex, passwordInstructions).required("Password is required")
  }),
  validate: (values, props) => {
    let errors = {};

    if (values.password1 !== values.password2) {
      errors.password2 = "Passwords are not the same";
    }

    return errors;
  },
  handleSubmit: (
    values,
    {
      props,
      setSubmitting,
      setErrors,
      setStatus,
    }
  ) => {
    // Submit forgot password
    props.resetPassword(values, {setSubmitting, setErrors, setStatus});
  }

})(BusinessPasswordResetForm);



// WEBPACK FOOTER //
// ./src/parts/BusinessPasswordResetForm.js